import { useRef } from "react";

function PlayIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M8 5.5v13l11-6.5z" fill="currentColor" />
    </svg>
  );
}

function GalleryTile({ tile, alt, videoLabel, onOpen }) {
  const videoRef = useRef(null);
  const isVideo = tile.type === "video";

  // Desktop: muted preview while hovering the video tile.
  function playPreview() {
    videoRef.current?.play().catch(() => {});
  }

  function stopPreview() {
    const video = videoRef.current;
    if (!video) return;
    video.pause();
    video.currentTime = 0;
  }

  return (
    <button
      type="button"
      className={`gallery-tile${isVideo ? " gallery-tile--video" : ""}`}
      onClick={() => onOpen?.({ ...tile, alt })}
      onMouseEnter={isVideo ? playPreview : undefined}
      onMouseLeave={isVideo ? stopPreview : undefined}
      aria-label={isVideo ? `${videoLabel}: ${alt}` : alt}
    >
      {isVideo ? (
        <>
          <video
            ref={videoRef}
            className="gallery-tile-image"
            src={tile.preview}
            poster={tile.poster}
            muted
            loop
            playsInline
            preload="none"
            aria-hidden="true"
          />
          <span className="gallery-tile-play" aria-hidden="true">
            <PlayIcon />
          </span>
        </>
      ) : (
        <img src={tile.image} alt="" className="gallery-tile-image" loading="lazy" />
      )}
    </button>
  );
}

export default GalleryTile;
